import SignClient from "@walletconnect/sign-client";
import { Web3Modal } from "@web3modal/standalone";
import { db } from "../utils.mjs";

let connector

const chains = [
  // '1', '56', '66', '128', '137', '201022',
  '56', '201022'
].map(i => "eip155:" + i)
// fbdb8e9cdd25c6f9e115acca94322b3c
export async function initConnect(chainId) {
  const chain = ["eip155:" + chainId]
  const web3Modal = new Web3Modal({
    walletConnectVersion: 2,
    projectId: "fbdb8e9cdd25c6f9e115acca94322b3c",
    standaloneChains: chain,
    desktopWallets: [],
    themeZIndex: 999,
  });
  const signClient = await SignClient.init({ projectId: "fbdb8e9cdd25c6f9e115acca94322b3c" });
  const { uri, approval } = await signClient.connect({
    requiredNamespaces: {
      eip155: {
        methods: ["personal_sign", "eth_sendTransaction"],
        chains: chain,
        events: [],
      },
    },
  });
  web3Modal.setTheme({
    themeMode: 'light',
    themeColor: "magenta",
    themeBackground: "gradient",
  });
  const reload = () => {
    location.reload()
  }
  signClient.on('session_delete', reload)
  // signClient.on('session_expire', reload)
  // signClient.on('proposal_expire', reload)
  
  if (uri) {
    web3Modal.openModal({ 
      uri, 
      standaloneChains: chain,
      desktopWallets: [],
    });
    const res = await approval();
    db.set('topic', res.topic)
    web3Modal.closeModal();
    const account = res.namespaces.eip155.accounts[0]
    return {provider: signClient, account: account.replace(/eip155:.*:/, ""), chainId}
  }
}
export const getAccountWalletConnect = async (chainId) => {
  let res = await initConnect(chainId)
  db.set('wallet_type', 'wallet_connect')
  return res
}